module.exports = __webpack_public_path__ + "static/img/9.ae14752.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/9.png
// module id = TjBm
// module chunks = 0